/* ── Scroll Restoration Fix ─────────────────────────────────
   Prevent browser from restoring scroll position on page load.
   Without this, browsers restore the last scroll position which
   causes the page to appear to "auto-scroll" on load.
   ─────────────────────────────────────────────────────────── */
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
window.addEventListener('load', function() {
  window.scrollTo(0, 0);
});

/* ============================================================
   HELLA GOOD CUP — Theme JS v6
   New features:
     - Coffee Finder Quiz modal (5-step, Mautic Form 3)
     - Cart abandonment beacon
     - OTO countdown timer
     - Product page: how-you-take-it, recipe pairing, upsell
     - Subscribe & Save tier selector + savings calc
     - Recipes page filter
     - Brew guides filter
     - Free Guide / Free Coffee funnel pages
     - Mautic contact submission helper
   ============================================================ */
(function () {
  'use strict';

  /* ── Utility ─────────────────────────────────────────────── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ── Mautic helper ───────────────────────────────────────── */
  // Submits a contact to Mautic via the embedded form endpoint
  function mauticSubmit(formId, fields) {
    // fields: { email, firstname, phone, ... }
    var mauticBase = 'https://mautic.brewsandteas.com';
    var data = new FormData();
    data.append('mauticform[formId]', formId);
    data.append('mauticform[return]', '');
    data.append('mauticform[messenger]', '1');
    Object.keys(fields).forEach(function(k) {
      data.append('mauticform[' + k + ']', fields[k] || '');
    });
    fetch(mauticBase + '/form/submit?formId=' + formId, {
      method: 'POST',
      body: data,
      mode: 'no-cors'
    }).catch(function() {});
  }

  /* ── Shopify Cart helpers ────────────────────────────────── */
  function addToCart(variantId, qty, props, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1, properties: props || {} })
    })
    .then(function(r) { return r.json(); })
    .then(function(d) { if (callback) callback(null, d); })
    .catch(function(e) { if (callback) callback(e); });
  }

  function getCart(callback) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(d) { callback(null, d); })
      .catch(function(e) { callback(e); });
  }

  function updateCartItem(key, qty, callback) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(d) { if (callback) callback(null, d); })
    .catch(function(e) { if (callback) callback(e); });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

    /* ── Cart Drawer ────────────────────────────────────── */
  var cartDrawer  = $('#cart-drawer');
  // FIXED: theme.liquid uses #site-overlay not #cart-overlay
  var cartOverlay = $('#cart-overlay') || $('#site-overlay');

   function openCart() {
    if (!cartDrawer) return;
    // FIXED: CSS uses .is-open not .open for cart-drawer
    cartDrawer.classList.add('is-open');
    cartDrawer.classList.add('open'); // fallback
    if (cartOverlay) { cartOverlay.classList.add('is-open'); cartOverlay.classList.add('open'); }
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.classList.remove('open');
    if (cartOverlay) { cartOverlay.classList.remove('is-open'); cartOverlay.classList.remove('open'); }
    document.body.style.overflow = '';
  }

  function refreshCartDrawer() {
    getCart(function(err, cart) {
      if (err || !cart) return;
      updateCartCount(cart.item_count);
      updateShippingBar(cart.total_price);
      renderCartItems(cart);
      updateCartTotal(cart.total_price);
    });
  }

  function updateCartCount(count) {
    // FIXED: added #header-cart-count and .header-cart-badge to match header HTML
    $$('.cart-count, .cart-count-badge, .header-cart-badge, #header-cart-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function updateShippingBar(totalCents) {
    var FREE_SHIPPING_THRESHOLD = 4900; // $49
    var fill = $('#cart-shipping-fill');
    var msg  = $('#cart-shipping-msg');
    if (!fill) return;
    var pct = Math.min(100, Math.round((totalCents / FREE_SHIPPING_THRESHOLD) * 100));
    fill.style.width = pct + '%';
    if (msg) {
      if (totalCents >= FREE_SHIPPING_THRESHOLD) {
        msg.textContent = '🎉 You\'ve unlocked free shipping!';
        msg.style.color = '#6DCDBF';
      } else {
        var remaining = formatMoney(FREE_SHIPPING_THRESHOLD - totalCents);
        msg.textContent = 'Add ' + remaining + ' more for free shipping';
        msg.style.color = '#8D6E63';
      }
    }
  }

  function renderCartItems(cart) {
    // FIXED: cart-drawer uses #cart-items not #cart-items-container
    var container = $('#cart-items-container') || $('#cart-items');
    if (!container) return;
    if (cart.item_count === 0) {
      container.innerHTML = '<div style="text-align:center;padding:40px 20px;color:#8D6E63;"><div style="font-size:3rem;margin-bottom:12px;">☕</div><p style="font-weight:600;">Your cart is empty</p><p style="font-size:0.85rem;margin-top:4px;">Add some hella good coffee!</p><a href="/collections/all" style="display:inline-block;margin-top:16px;padding:10px 24px;background:#6DCDBF;color:white;border-radius:999px;font-weight:700;font-size:0.88rem;text-decoration:none;">Shop Now</a></div>';
      return;
    }
    var html = '';
    cart.items.forEach(function(item) {
      html += '<div class="cart-item" data-key="' + item.key + '">' +
        '<img class="cart-item-img" src="' + item.image + '" alt="' + item.product_title + '">' +
        '<div class="cart-item-info">' +
          '<div class="cart-item-name">' + item.product_title + '</div>' +
          '<div class="cart-item-variant">' + (item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div>' +
          '<div class="cart-item-qty">' +
            '<button class="cart-qty-btn" data-action="decrease" data-key="' + item.key + '">−</button>' +
            '<span style="font-weight:700;font-size:0.88rem;color:#3E2723;min-width:20px;text-align:center;">' + item.quantity + '</span>' +
            '<button class="cart-qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
    });
    container.innerHTML = html;

    // Qty buttons
    $$('.cart-qty-btn', container).forEach(function(btn) {
      on(btn, 'click', function() {
        var key = btn.dataset.key;
        var action = btn.dataset.action;
        var currentQty = parseInt(btn.parentElement.querySelector('span').textContent);
        var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
        updateCartItem(key, newQty, function() { refreshCartDrawer(); });
      });
    });
  }

  function updateCartTotal(totalCents) {
    // FIXED: cart-drawer uses #cart-subtotal-amount not #cart-total-price
    var el = $('#cart-total-price') || $('#cart-subtotal-amount');
    if (el) el.textContent = formatMoney(totalCents);
  }

  // Wire cart open/close — FIXED: added #cart-trigger to match header HTML
  $$('#cart-toggle, #cart-trigger, .cart-toggle, [data-cart-open]').forEach(function(btn) {
    on(btn, 'click', openCart);
  });
  $$('#cart-close, [data-cart-close]').forEach(function(btn) {
    on(btn, 'click', closeCart);
  });
  on(cartOverlay, 'click', closeCart);

  // Initial cart count
  getCart(function(err, cart) {
    if (!err && cart) updateCartCount(cart.item_count);
  });

  /* ── Add to Cart buttons ─────────────────────────────────── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    var variantId = btn.dataset.variantId || btn.dataset.addToCart;
    if (!variantId) return;
    var qty = parseInt(btn.dataset.qty || '1');
    var origText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    addToCart(variantId, qty, {}, function(err) {
      if (err) {
        btn.textContent = 'Error';
        setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 2000);
        return;
      }
      btn.textContent = '✓ Added!';
      setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 1500);
      refreshCartDrawer();
      openCart();
    });
  });

    /* ── Coffee Finder Quiz Modal ────────────────────────────── */
  // Works with static HTML quiz steps in snippets/coffee-quiz-modal.liquid
  var quizOverlay = $('#quiz-overlay');
  var quizModal   = $('#quiz-modal');
  var quizCurrentStep = 1;
  var quizTotalSteps  = 5;
  var quizAnswers = {};

  function openQuiz() {
    quizCurrentStep = 1;
    quizAnswers = {};
    if (quizOverlay) { quizOverlay.style.display = 'block'; }
    if (quizModal)   { quizModal.style.display = 'flex'; }
    document.body.style.overflow = 'hidden';
    quizShowStep(1);
  }
  function closeQuiz() {
    if (quizOverlay) quizOverlay.style.display = 'none';
    if (quizModal)   quizModal.style.display = 'none';
    document.body.style.overflow = '';
  }
  function quizShowStep(step) {
    $$('.quiz-step').forEach(function(el) { el.classList.remove('active'); });
    var target = step === 'results' ? $('#quiz-step-results') : $('#quiz-step-' + step);
    if (target) target.classList.add('active');
    var fill = $('#quiz-progress-fill');
    var label = $('#quiz-progress-label');
    if (step === 'results') {
      if (fill) fill.style.width = '100%';
      if (label) label.textContent = 'Complete!';
    } else {
      var pct = Math.round(((step - 1) / quizTotalSteps) * 100);
      if (fill) fill.style.width = pct + '%';
      if (label) label.textContent = 'Step ' + step + ' of ' + quizTotalSteps;
    }
  }
  window.quizNext = function(fromStep) {
    var nextStep = fromStep + 1;
    if (nextStep > quizTotalSteps) { quizShowStep('results'); }
    else { quizCurrentStep = nextStep; quizShowStep(nextStep); }
  };
  window.quizBack = function(fromStep) {
    var prevStep = fromStep - 1;
    if (prevStep < 1) return;
    quizCurrentStep = prevStep;
    quizShowStep(prevStep);
  };
  function wireQuizCards(selector, stepNum, autoAdvance) {
    $$(selector).forEach(function(card) {
      on(card, 'click', function() {
        var stepEl = $('#quiz-step-' + stepNum);
        if (stepEl) $$(selector, stepEl).forEach(function(c) { c.classList.remove('selected'); });
        card.classList.add('selected');
        quizAnswers['step' + stepNum] = card.dataset.value;
        if (autoAdvance) { setTimeout(function() { window.quizNext(stepNum); }, 320); }
      });
    });
  }
  function wireFlavorCards() {
    $$('.quiz-flavor-card').forEach(function(card) {
      on(card, 'click', function() {
        card.classList.toggle('selected');
        var selected = $$('.quiz-flavor-card.selected');
        quizAnswers.flavors = selected.map(function(c) { return c.dataset.value; });
        var nextBtn = $('#quiz-next-2');
        if (nextBtn) nextBtn.disabled = selected.length === 0;
      });
    });
  }
  var quizCloseBtn = $('#quiz-close');
  on(quizCloseBtn, 'click', closeQuiz);
  on(quizOverlay, 'click', closeQuiz);
  $$('[data-quiz-open], .quiz-open-btn, #quiz-open-btn, .header-quiz-btn, .announce-quiz-btn, .quiz-trigger, .quiz-card-cta').forEach(function(btn) {
    on(btn, 'click', openQuiz);
  });
  var captureForm = $('#quiz-capture-form');
  if (captureForm) {
    on(captureForm, 'submit', function(e) {
      e.preventDefault();
      var email = $('#quiz-email');
      var fname = $('#quiz-first-name');
      var phone = $('#quiz-phone');
      if (!email || !email.value) { if (email) email.style.borderColor = '#D76F3C'; return; }
      var submitBtn = $('#quiz-submit-btn');
      var submitText = $('#quiz-submit-text');
      var submitLoading = $('#quiz-submit-loading');
      if (submitBtn) submitBtn.disabled = true;
      if (submitText) submitText.style.display = 'none';
      if (submitLoading) submitLoading.style.display = 'inline';
      mauticSubmit(3, {
        email: email.value,
        firstname: fname ? fname.value : '',
        phone: phone ? phone.value : '',
        quiz_brew: quizAnswers.step1 || '',
        quiz_flavors: (quizAnswers.flavors || []).join(', '),
        quiz_roast: quizAnswers.step3 || '',
        quiz_experience: quizAnswers.step4 || ''
      });
      localStorage.setItem('hgc_quiz_email', email.value);
      localStorage.setItem('hgc_quiz_done', '1');
      populateQuizResults();
      quizShowStep('results');
    });
  }
  function populateQuizResults() {
    var QUIZ_RESULTS = {
      fruity:   { product: 'Smith River Single Origin', handle: 'smith-river', desc: 'Bright, clean, and full of citrus notes. Perfect for pour-over.', coupon: 'QUIZ10', recipes: ['V60 Recipe', 'Cold Brew Guide', 'Chemex Method'] },
      bold:     { product: 'Broken Top Dark', handle: 'broken-top-dark', desc: 'Bold, smoky, and full-bodied. Deep cocoa and caramel notes.', coupon: 'QUIZ10', recipes: ['Espresso Guide', 'French Press', 'Moka Pot Recipe'] },
      balanced: { product: 'High Lakes Blend', handle: 'high-lakes-blend', desc: 'Balanced sweetness and body. The most versatile roast for any method.', coupon: 'QUIZ10', recipes: ['Drip Coffee Guide', 'Kalita Wave', 'Aeropress Recipe'] },
      light:    { product: 'Mexico Single Origin', handle: 'mexico-single-origin', desc: "Delicate, sweet, and nuanced. Showcases the bean's natural character.", coupon: 'QUIZ10', recipes: ['Pour Over Guide', 'Chemex Method', 'Cold Brew Recipe'] }
    };
    var result;
    var flavors = quizAnswers.flavors || [];
    var roast = quizAnswers.step3 || '';
    var brew = quizAnswers.step1 || '';
    if (flavors.indexOf('fruity') >= 0 || roast === 'light') result = QUIZ_RESULTS.fruity;
    else if (roast === 'dark' || brew === 'espresso') result = QUIZ_RESULTS.bold;
    else if (roast === 'medium') result = QUIZ_RESULTS.balanced;
    else result = QUIZ_RESULTS.light;
    var productEl = $('#quiz-result-product');
    if (productEl) {
      productEl.innerHTML = '<div style="background:#FAF6F0;border:1px solid rgba(62,39,35,0.1);border-radius:14px;padding:20px;text-align:center;">' +
        '<div style="font-size:2.5rem;margin-bottom:8px;">\u2615</div>' +
        '<div style="font-family:\'Playfair Display\',serif;font-weight:700;font-size:1.1rem;color:#3E2723;margin-bottom:6px;">' + result.product + '</div>' +
        '<div style="font-size:0.82rem;color:#5D4037;line-height:1.6;margin-bottom:12px;">' + result.desc + '</div>' +
        '<a href="/products/' + result.handle + '" style="display:inline-flex;align-items:center;gap:6px;padding:10px 24px;background:#6DCDBF;color:white;border-radius:999px;font-weight:700;font-size:0.88rem;text-decoration:none;">Shop This Coffee \u2192</a>' +
      '</div>';
    }
    var codeEl = $('#quiz-discount-code');
    if (codeEl) codeEl.textContent = result.coupon;
    var shopCta = $('#quiz-shop-cta');
    if (shopCta) shopCta.href = '/products/' + result.handle;
    var recipesGrid = $('#quiz-recipes-grid');
    if (recipesGrid) {
      recipesGrid.innerHTML = result.recipes.map(function(r) {
        return '<a href="/pages/recipes" class="quiz-recipe-card"><span class="quiz-recipe-name">' + r + '</span></a>';
      }).join('');
    }
  }
  wireQuizCards('.quiz-visual-card', 1, true);
  wireFlavorCards();
  wireQuizCards('.quiz-roast-card', 3, true);
  wireQuizCards('.quiz-journey-card', 4, true);
  window.openQuiz = openQuiz;
  window.closeQuiz = closeQuiz;
  window.HGCQuiz = { open: openQuiz, close: closeQuiz };

/* ── Cart Abandonment Beacon ─────────────────────────────── */
  var cartAbandonSent = false;
  function sendCartAbandonBeacon() {
    if (cartAbandonSent) return;
    var email = localStorage.getItem('hgc_quiz_email') || localStorage.getItem('hgc_email');
    if (!email) return;
    getCart(function(err, cart) {
      if (err || !cart || cart.item_count === 0) return;
      cartAbandonSent = true;
      mauticSubmit(5, { // Mautic Form 5 = cart abandonment
        email: email,
        cart_total: formatMoney(cart.total_price),
        cart_items: cart.items.map(function(i) { return i.product_title; }).join(', ')
      });
    });
  }

  // Trigger on page hide / visibility change
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') sendCartAbandonBeacon();
  });
  window.addEventListener('beforeunload', sendCartAbandonBeacon);

  /* ── OTO Countdown Timer ─────────────────────────────────── */
  function initOTOTimer() {
    var timerEl = $('#oto-timer');
    if (!timerEl) return;

    var endTime = localStorage.getItem('hgc_oto_end');
    if (!endTime) {
      endTime = Date.now() + (15 * 60 * 1000); // 15 minutes
      localStorage.setItem('hgc_oto_end', endTime);
    }
    endTime = parseInt(endTime);

    function tick() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        // Timer expired — hide offer or show expired message
        var expiredEl = $('#oto-expired');
        var offerEl   = $('#oto-offer');
        if (expiredEl) expiredEl.style.display = 'block';
        if (offerEl)   offerEl.style.display = 'none';
        return;
      }
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000);
      var minsEl = timerEl.querySelector('[data-timer-mins]');
      var secsEl = timerEl.querySelector('[data-timer-secs]');
      if (minsEl) minsEl.textContent = String(mins).padStart(2, '0');
      if (secsEl) secsEl.textContent = String(secs).padStart(2, '0');
      setTimeout(tick, 1000);
    }
    tick();
  }
  initOTOTimer();

  /* ── Product Page: How You Take It ──────────────────────── */
  function initProductPage() {
    // Grind selector
    $$('.grind-option').forEach(function(opt) {
      on(opt, 'click', function() {
        var group = opt.closest('.grind-selector');
        if (!group) return;
        $$('.grind-option', group).forEach(function(o) { o.classList.remove('active'); });
        opt.classList.add('active');
        // Update variant if data-variant-id present
        var variantId = opt.dataset.variantId;
        var addBtn = $('#product-add-btn');
        if (addBtn && variantId) addBtn.dataset.variantId = variantId;
      });
    });

    // How you take it selector
    $$('.how-option').forEach(function(opt) {
      on(opt, 'click', function() {
        $$('.how-option').forEach(function(o) { o.classList.remove('active'); });
        opt.classList.add('active');
        // Show matching recipe
        var method = opt.dataset.method;
        $$('.recipe-suggestion').forEach(function(r) {
          r.style.display = r.dataset.method === method ? 'block' : 'none';
        });
      });
    });

    // Subscribe toggle
    var subscribeToggle = $('#subscribe-toggle');
    var priceEl         = $('#product-price');
    var originalPrice   = priceEl ? priceEl.dataset.original : null;
    var subscribePrice  = priceEl ? priceEl.dataset.subscribe : null;

    if (subscribeToggle && priceEl) {
      on(subscribeToggle, 'change', function() {
        if (subscribeToggle.checked) {
          priceEl.textContent = subscribePrice || priceEl.textContent;
          priceEl.style.color = '#6DCDBF';
        } else {
          priceEl.textContent = originalPrice || priceEl.textContent;
          priceEl.style.color = '';
        }
      });
    }

    // Product image gallery
    $$('.product-thumb').forEach(function(thumb) {
      on(thumb, 'click', function() {
        var mainImg = $('#product-main-img');
        if (mainImg && thumb.dataset.src) {
          mainImg.src = thumb.dataset.src;
        }
        $$('.product-thumb').forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });

    // Upsell add to cart
    $$('[data-upsell-add]').forEach(function(btn) {
      on(btn, 'click', function() {
        var variantId = btn.dataset.upsellAdd;
        if (!variantId) return;
        var origText = btn.textContent;
        btn.textContent = 'Adding…';
        btn.disabled = true;
        addToCart(variantId, 1, { upsell: 'true' }, function(err) {
          btn.textContent = err ? 'Error' : '✓ Added!';
          setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 1500);
          if (!err) { refreshCartDrawer(); openCart(); }
        });
      });
    });
  }
  initProductPage();

  /* ── Subscribe & Save Page ───────────────────────────────── */
  function initSubscribePage() {
    var tierCards = $$('.sub-tier-card');
    if (!tierCards.length) return;

    tierCards.forEach(function(card) {
      on(card, 'click', function() {
        tierCards.forEach(function(c) { c.classList.remove('selected'); });
        card.classList.add('selected');
        // Update CTA price display
        var priceDisplay = $('#selected-tier-price');
        if (priceDisplay) priceDisplay.textContent = card.dataset.price || '';
      });
    });

    // Savings calculator
    var calcInput = $('#savings-bags');
    var calcResult = $('#savings-result');
    if (calcInput && calcResult) {
      on(calcInput, 'input', function() {
        var bags = parseInt(calcInput.value) || 1;
        var regularPrice = bags * 17.99;
        var subPrice = bags * 15.29; // ~15% off
        var savings = regularPrice - subPrice;
        calcResult.textContent = '$' + savings.toFixed(2) + '/month saved';
      });
    }
  }
  initSubscribePage();

  /* ── Recipes Page Filter ─────────────────────────────────── */
  function initRecipesPage() {
    var filterTabs = $$('.recipe-filter-tab');
    if (!filterTabs.length) return;

    filterTabs.forEach(function(tab) {
      on(tab, 'click', function() {
        filterTabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var filter = tab.dataset.filter;
        $$('.recipe-card').forEach(function(card) {
          var method = card.dataset.method || 'all';
          card.style.display = (filter === 'all' || method === filter) ? '' : 'none';
        });
        // Update visible count
        var countEl = $('#recipe-count');
        if (countEl) {
          var visible = $$('.recipe-card').filter(function(c) { return c.style.display !== 'none'; }).length;
          countEl.textContent = visible + ' recipes';
        }
      });
    });

    // Recipe search
    var recipeSearch = $('#recipe-search');
    if (recipeSearch) {
      on(recipeSearch, 'input', function() {
        var q = recipeSearch.value.toLowerCase();
        $$('.recipe-card').forEach(function(card) {
          var text = card.textContent.toLowerCase();
          card.style.display = text.includes(q) ? '' : 'none';
        });
      });
    }
  }
  initRecipesPage();

  /* ── Free Guide Page ─────────────────────────────────────── */
  function initFreeGuidePage() {
    var form = $('#free-guide-form');
    if (!form) return;
    on(form, 'submit', function(e) {
      e.preventDefault();
      var email = form.querySelector('#guide-email');
      var fname = form.querySelector('#guide-fname');
      if (!email || !email.value) return;
      // Submit to Mautic Form 1 (free guide)
      mauticSubmit(1, {
        email: email.value,
        firstname: fname ? fname.value : ''
      });
      localStorage.setItem('hgc_email', email.value);
      // Show success state
      var formWrap = $('#guide-form-wrap');
      var successWrap = $('#guide-success-wrap');
      if (formWrap) formWrap.style.display = 'none';
      if (successWrap) successWrap.style.display = 'block';
      // Redirect to free coffee page after 2s
      setTimeout(function() {
        window.location.href = '/pages/free-coffee';
      }, 2000);
    });
  }
  initFreeGuidePage();

  /* ── Free Coffee Tripwire Page ───────────────────────────── */
  function initFreeCoffeePage() {
    var form = $('#free-coffee-form');
    if (!form) return;
    on(form, 'submit', function(e) {
      e.preventDefault();
      var email = form.querySelector('#coffee-email');
      var fname = form.querySelector('#coffee-fname');
      if (!email || !email.value) return;
      mauticSubmit(2, {
        email: email.value,
        firstname: fname ? fname.value : ''
      });
      localStorage.setItem('hgc_email', email.value);
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.textContent = 'Processing…'; btn.disabled = true; }
      // Redirect to Shopify checkout or order success
      setTimeout(function() {
        window.location.href = '/pages/order-success';
      }, 1500);
    });
  }
  initFreeCoffeePage();

  /* ── OTO Upsell Page ─────────────────────────────────────── */
  function initOTOPage() {
    var acceptBtn = $('#oto-accept-btn');
    var declineBtn = $('#oto-decline-btn');

    on(acceptBtn, 'click', function() {
      var variantId = acceptBtn.dataset.variantId;
      if (!variantId) { window.location.href = '/pages/order-confirmed'; return; }
      acceptBtn.textContent = 'Adding to your order…';
      acceptBtn.disabled = true;
      addToCart(variantId, 1, { oto: 'upsell1' }, function(err) {
        if (err) {
          acceptBtn.textContent = 'Error — try again';
          acceptBtn.disabled = false;
          return;
        }
        window.location.href = '/checkout';
      });
    });

    on(declineBtn, 'click', function() {
      // Redirect to OTO 2 downsell or confirmation
      var downsellUrl = declineBtn.dataset.downsell || '/pages/order-confirmed';
      window.location.href = downsellUrl;
    });
  }
  initOTOPage();

  /* ── Brew Guides Filter ──────────────────────────────────── */
  function initBrewGuidesPage() {
    var filterBtns = $$('.brew-filter-btn');
    if (!filterBtns.length) return;
    filterBtns.forEach(function(btn) {
      on(btn, 'click', function() {
        filterBtns.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var filter = btn.dataset.filter;
        $$('.brew-guide-card').forEach(function(card) {
          var method = card.dataset.method || 'all';
          card.style.display = (filter === 'all' || method === filter) ? '' : 'none';
        });
      });
    });
  }
  initBrewGuidesPage();

  /* ── Email Popup (v6 version) ────────────────────────────── */
  function initEmailPopup() {
    var popup = $('#email-popup');
    if (!popup) return;
    if (localStorage.getItem('hgc_popup_shown')) return;

    function showPopup() {
      popup.classList.add('show');
    }
    function hidePopup() {
      popup.classList.remove('show');
      localStorage.setItem('hgc_popup_shown', '1');
    }

    var closeBtn = popup.querySelector('[data-popup-close]');
    on(closeBtn, 'click', hidePopup);

    var popupForm = popup.querySelector('form');
    if (popupForm) {
      on(popupForm, 'submit', function(e) {
        e.preventDefault();
        var emailInput = popupForm.querySelector('input[type="email"]');
        if (!emailInput || !emailInput.value) return;
        mauticSubmit(4, { email: emailInput.value }); // Form 4 = popup
        localStorage.setItem('hgc_email', emailInput.value);
        var successEl = popup.querySelector('[data-popup-success]');
        if (successEl) {
          popupForm.style.display = 'none';
          successEl.style.display = 'block';
        }
        setTimeout(hidePopup, 3000);
      });
    }

    // Show after 8 seconds or on exit intent
    setTimeout(showPopup, 8000);
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY < 10) showPopup();
    }, { once: true });
  }
  initEmailPopup();

  /* ── Announcement Bar Rotation ───────────────────────────── */
  function initAnnouncementBar() {
    var bar = $('.announcement-bar');
    if (!bar) return;
    // Pause on hover
    var track = bar.querySelector('.announcement-items');
    if (track) {
      on(bar, 'mouseenter', function() { track.style.animationPlayState = 'paused'; });
      on(bar, 'mouseleave', function() { track.style.animationPlayState = 'running'; });
    }
  }
  initAnnouncementBar();

  /* ── Mobile Menu ─────────────────────────────────────────── */
  function initMobileMenu() {
    // FIXED: updated IDs to match header HTML
    var openBtn  = $('#mobile-menu-open') || $('#mobile-menu-trigger');
    var closeBtn = $('#mobile-menu-close') || $('#mobile-nav-close');
    var menu     = $('#mobile-menu') || $('#mobile-nav');
    var overlay  = $('#mobile-nav-overlay');

    function openMenu() {
      if (!menu) return;
      // FIXED: CSS uses .is-open not .open for the mobile-nav drawer
      menu.classList.add('is-open');
      menu.classList.add('open'); // fallback
      if (overlay) { overlay.style.display = 'block'; overlay.classList.add('is-open'); }
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      if (!menu) return;
      menu.classList.remove('is-open');
      menu.classList.remove('open');
      if (overlay) { overlay.style.display = 'none'; overlay.classList.remove('is-open'); }
      document.body.style.overflow = '';
    }
    on(openBtn, 'click', openMenu);
    on(closeBtn, 'click', closeMenu);
    on(overlay, 'click', closeMenu);
  }
  initMobileMenu();

  /* ── Search Bar ──────────────────────────────────────────── */
  function initSearch() {
    var toggleBtn = $('#search-toggle');
    var searchBar = $('#search-bar');
    var closeBtn  = $('#search-close');
    var input     = $('#search-input');
    on(toggleBtn, 'click', function() {
      if (!searchBar) return;
      var open = searchBar.style.display === 'block';
      searchBar.style.display = open ? 'none' : 'block';
      if (!open && input) input.focus();
    });
    on(closeBtn, 'click', function() {
      if (searchBar) searchBar.style.display = 'none';
    });
  }
  initSearch();

  /* ── Filter Tabs (Homepage Products) ────────────────────── */
  document.addEventListener('click', function(e) {
    // FIXED: support both .filter-tab (old) and .fp-filter-btn (new featured-products section)
    var tab = e.target.closest('.filter-tab, .filter-tab-mobile, .fp-filter-btn');
    if (!tab) return;
    var filter = tab.dataset.filter;
    // Deactivate all tabs in the same container
    var container = tab.closest('.fp-filters, .filter-tabs-wrap, .filter-tabs') || document;
    $$('.filter-tab, .filter-tab-mobile, .fp-filter-btn', container).forEach(function(t) { t.classList.remove('active'); });
    tab.classList.add('active');
    // Support both .product-card (old) and .fp-card (new)
    var cardContainer = tab.closest('section') || document;
    $$('.product-card, .fp-card', cardContainer).forEach(function(card) {
      var cardFilter = (card.dataset.filter || '').toLowerCase().trim();
      var show = filter === 'All' || filter === 'all' || cardFilter === filter.toLowerCase() || cardFilter.indexOf(filter.toLowerCase()) !== -1;
      card.style.display = show ? '' : 'none';
      card.classList.toggle('hidden', !show);
    });
  });

  /* ── Scroll Arrows ───────────────────────────────────── */
  document.addEventListener('click', function(e) {
    // FIXED: support both .scroll-arrow (old) and .fp-arrow (new featured-products section)
    var arrow = e.target.closest('.scroll-arrow, .fp-arrow');
    if (!arrow) return;
    // Find the scroll row
    var section = arrow.closest('section, .fp-layout-wrap, [data-scroll-wrap]');
    // For fp-arrow, look for fp-scroll-row by ID or class
    var row = null;
    if (arrow.classList.contains('fp-arrow')) {
      row = document.getElementById('fp-scroll-row') || (section && section.querySelector('.fp-scroll-row'));
    } else {
      var wrap = arrow.closest('[data-scroll-wrap]') || arrow.closest('.products-scroll-wrap') || arrow.parentElement;
      row = wrap ? wrap.querySelector('[data-scroll-row], .products-scroll-row, .reviews-track') : null;
    }
    if (!row) return;
    var dir = (arrow.classList.contains('scroll-arrow-left') || arrow.classList.contains('fp-arrow-prev')) ? -1 : 1;
    row.scrollBy({ left: dir * 300, behavior: 'smooth' });
  });

  /* ── Grind Selectors ─────────────────────────────────────── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.grind-btn');
    if (!btn) return;
    var group = btn.closest('.grind-selector, .bundle-grind');
    if (!group) return;
    $$('.grind-btn', group).forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
  });

  /* ── Newsletter Form ─────────────────────────────────────── */
  var newsletterForm = $('#newsletter-form');
  if (newsletterForm) {
    on(newsletterForm, 'submit', function(e) {
      e.preventDefault();
      var emailInput = newsletterForm.querySelector('#newsletter-email, input[type="email"]');
      if (!emailInput || !emailInput.value) return;
      mauticSubmit(4, { email: emailInput.value });
      localStorage.setItem('hgc_email', emailInput.value);
      var successEl = $('#newsletter-success');
      if (successEl) {
        newsletterForm.style.display = 'none';
        successEl.style.display = 'flex';
      }
    });
  }

  /* ── Sticky header shadow on scroll ─────────────────────── */
  var header = $('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 16px rgba(62,39,35,0.1)' : '';
    }, { passive: true });
  }

  /* ── Smooth scroll for anchor links ─────────────────────── */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

})();

/* ============================================================
   BREW CAROUSEL — Left/Right scroll with arrows + dots
   ============================================================ */
(function() {
  var track = document.getElementById('brew-carousel-track');
  var prevBtn = document.getElementById('brew-prev');
  var nextBtn = document.getElementById('brew-next');
  var dotsContainer = document.getElementById('brew-carousel-dots');
  if (!track) return;

  var CARD_WIDTH = 240; // card 220px + gap 20px

  function updateDots() {
    if (!dotsContainer) return;
    var dots = dotsContainer.querySelectorAll('.brew-dot');
    var idx = Math.floor(track.scrollLeft / (CARD_WIDTH * 2));
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i === idx);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: -(CARD_WIDTH * 2), behavior: 'smooth' });
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      track.scrollBy({ left: CARD_WIDTH * 2, behavior: 'smooth' });
    });
  }
  if (dotsContainer) {
    dotsContainer.querySelectorAll('.brew-dot').forEach(function(dot) {
      dot.addEventListener('click', function() {
        var idx = parseInt(dot.getAttribute('data-index'));
        track.scrollTo({ left: idx * CARD_WIDTH * 2, behavior: 'smooth' });
      });
    });
  }
  track.addEventListener('scroll', updateDots, { passive: true });
})();

/* ============================================================
   QUIZ RESULTS — Inject recipe recommendations
   ============================================================ */
(function() {
  var RECIPE_MAP = {
    'Drip Machine': [
      { name: 'Classic Drip Coffee', url: '/pages/recipes#drip' },
      { name: 'Overnight Drip Concentrate', url: '/pages/recipes#drip' },
      { name: 'Cinnamon Maple Drip', url: '/pages/recipes#drip' },
      { name: 'Honey Drip Latte', url: '/pages/recipes#drip' }
    ],
    'Pour Over': [
      { name: 'Classic Pour Over', url: '/pages/recipes#pour-over' },
      { name: 'Iced Pour Over', url: '/pages/recipes#pour-over' },
      { name: 'Bloom & Bloom Pour Over', url: '/pages/recipes#pour-over' },
      { name: 'Flash Brew Lemonade', url: '/pages/recipes#pour-over' }
    ],
    'French Press': [
      { name: 'Classic French Press', url: '/pages/recipes#french-press' },
      { name: 'Spiced French Press', url: '/pages/recipes#french-press' },
      { name: 'French Press Cold Brew', url: '/pages/recipes#french-press' },
      { name: 'Honey French Press', url: '/pages/recipes#french-press' }
    ],
    'Espresso': [
      { name: 'Classic Espresso Shot', url: '/pages/recipes#espresso' },
      { name: 'Vanilla Latte', url: '/pages/recipes#espresso' },
      { name: 'Cortado', url: '/pages/recipes#espresso' },
      { name: 'Flat White', url: '/pages/recipes#espresso' }
    ],
    'AeroPress': [
      { name: 'Classic AeroPress', url: '/pages/recipes#aeropress' },
      { name: 'Inverted AeroPress', url: '/pages/recipes#aeropress' },
      { name: 'AeroPress Cold Brew', url: '/pages/recipes#aeropress' },
      { name: 'AeroPress Americano', url: '/pages/recipes#aeropress' }
    ],
    'Cold Brew': [
      { name: 'Classic Cold Brew', url: '/pages/recipes#cold-brew' },
      { name: 'Nitro Cold Brew', url: '/pages/recipes#cold-brew' },
      { name: 'Cold Brew Tonic', url: '/pages/recipes#cold-brew' },
      { name: 'Vanilla Cold Brew Float', url: '/pages/recipes#cold-brew' }
    ]
  };

  function injectQuizRecipes(brewLabel) {
    var resultsEl = document.getElementById('quiz-results');
    if (!resultsEl) return;
    var existing = resultsEl.querySelector('.quiz-recipes-section');
    if (existing) existing.remove();

    var recipes = RECIPE_MAP[brewLabel] || RECIPE_MAP['Pour Over'];
    var html = '<div class="quiz-recipes-section">';
    html += '<p class="quiz-recipes-title">Recipes matched to your brew style</p>';
    html += '<div class="quiz-recipes-grid">';
    recipes.forEach(function(r) {
      html += '<a href="' + r.url + '" class="quiz-recipe-card">';
      html += '<span class="quiz-recipe-name">' + r.name + '</span>';
      html += '<span class="quiz-recipe-method">' + brewLabel + '</span>';
      html += '</a>';
    });
    html += '</div>';
    html += '<a href="/pages/recipes" class="quiz-recipes-all-link">Browse all 80+ recipes →</a>';
    html += '</div>';

    var actionsEl = resultsEl.querySelector('.quiz-result-actions, .quiz-coupon-section');
    if (actionsEl) {
      actionsEl.insertAdjacentHTML('afterend', html);
    } else {
      resultsEl.insertAdjacentHTML('beforeend', html);
    }
  }

  /* Patch the existing showResults function */
  var _origShowResults = window.showResults;
  window.showResults = function(answers) {
    if (_origShowResults) _origShowResults(answers);
    var brewLabel = answers && answers.brew ? answers.brew : 'Pour Over';
    injectQuizRecipes(brewLabel);
  };
})();

/* ============================================================
   UPSELL CHAIN — Club Tier (after subscription upsell)
   ============================================================ */
(function() {
  var clubBanner = document.getElementById('club-tier-upsell');
  if (!clubBanner) return;

  var acceptBtn = clubBanner.querySelector('.club-accept-btn');
  var declineBtn = clubBanner.querySelector('.club-decline-btn');

  if (acceptBtn) {
    acceptBtn.addEventListener('click', function() {
      acceptBtn.textContent = 'Joining the Club…';
      acceptBtn.disabled = true;
      /* Submit to Mautic Club sequence (Form 7) */
      if (typeof mauticSubmit === 'function') {
        mauticSubmit(7, {
          email: localStorage.getItem('hgc_email') || '',
          tags: 'hgc-club-member'
        });
      }
      setTimeout(function() {
        window.location.href = '/pages/order-success?step=club-confirmed';
      }, 800);
    });
  }

  if (declineBtn) {
    declineBtn.addEventListener('click', function() {
      clubBanner.style.display = 'none';
      var confirmSection = document.getElementById('order-confirm-section');
      if (confirmSection) confirmSection.style.display = 'block';
    });
  }
})();

/* ============================================================
   PRODUCT PAGE — How You Take It → Recipe + Discounted Upsell
   ============================================================ */
(function() {
  var TAKE_IT_MAP = {
    black: {
      recipe: 'Classic Pour Over',
      recipeUrl: '/pages/recipes#pour-over',
      coffee: 'Ethiopia Yirgacheffe',
      coffeeUrl: '/products/ethiopia-yirgacheffe',
      discount: '15% off',
      note: 'Bright, floral notes — perfect black'
    },
    milk: {
      recipe: 'Vanilla Latte',
      recipeUrl: '/pages/recipes#espresso',
      coffee: 'House Blend',
      coffeeUrl: '/products/house-blend',
      discount: '15% off',
      note: 'Rich, chocolatey — pairs beautifully with milk'
    },
    sweet: {
      recipe: 'Maple Drip Latte',
      recipeUrl: '/pages/recipes#drip',
      coffee: 'Guatemala Huehuetenango',
      coffeeUrl: '/products/guatemala-huehuetenango',
      discount: '15% off',
      note: 'Brown sugar, caramel notes — made for sweetness'
    },
    iced: {
      recipe: 'Classic Cold Brew',
      recipeUrl: '/pages/recipes#cold-brew',
      coffee: 'Cold Brew Blend',
      coffeeUrl: '/products/cold-brew-blend',
      discount: '15% off',
      note: 'Smooth, low-acid — built for cold'
    }
  };

  document.querySelectorAll('.take-it-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.take-it-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');

      var style = btn.getAttribute('data-style');
      var match = TAKE_IT_MAP[style];
      var panel = document.getElementById('take-it-recommendation');
      if (!match || !panel) return;

      panel.innerHTML = [
        '<div class="take-it-panel" style="background:rgba(109,205,191,0.06);border:1px solid rgba(109,205,191,0.2);border-radius:14px;padding:20px;margin-top:16px;">',
        '  <p style="font-family:\'DM Sans\',sans-serif;font-size:0.82rem;color:#8D6E63;margin-bottom:8px;">Recipe for you:</p>',
        '  <a href="' + match.recipeUrl + '" style="font-family:\'Playfair Display\',serif;font-size:1rem;font-weight:700;color:#3E2723;text-decoration:none;display:block;margin-bottom:16px;">' + match.recipe + ' →</a>',
        '  <div style="background:white;border-radius:12px;padding:16px;display:flex;align-items:center;gap:14px;border:1px solid rgba(62,39,35,0.08);">',
        '    <div style="flex:1;">',
        '      <span style="display:inline-block;background:#D76F3C;color:white;font-size:0.72rem;font-weight:700;padding:3px 10px;border-radius:20px;margin-bottom:6px;">' + match.discount + ' to try this recipe</span>',
        '      <p style="font-family:\'Playfair Display\',serif;font-size:0.95rem;font-weight:700;color:#3E2723;margin-bottom:4px;">' + match.coffee + '</p>',
        '      <p style="font-family:\'DM Sans\',sans-serif;font-size:0.78rem;color:#7A6B5D;margin-bottom:12px;">' + match.note + '</p>',
        '      <a href="' + match.coffeeUrl + '?discount=RECIPE15" style="display:inline-block;background:#6DCDBF;color:white;font-family:\'DM Sans\',sans-serif;font-weight:700;font-size:0.82rem;padding:9px 18px;border-radius:999px;text-decoration:none;">Add to Cart — ' + match.discount + '</a>',
        '    </div>',
        '  </div>',
        '</div>'
      ].join('');
      panel.style.display = 'block';
    });
  });
})();
